export const LIST_SEARCH = 'LIST_SEARCH';
export const LIST_PAGE = 'LIST_PAGE';